/**
 * Turns `{ paymentMethod, displayName }` entries from the payment methods API into filter
 * options. Codes sharing a display name (e.g. BACS and BACS_CREDIT -> "Bacs") collapse into
 * one option whose value is the comma-separated code list the payments API filters on.
 *
 * @param {Array<{ paymentMethod: string, displayName?: string }>} methods
 * @returns {Array<{ value: string, label: string }>}
 */
export const toPaymentMethodOptions = (methods) => {
    const codesByLabel = new Map();
    (methods || []).forEach(({ paymentMethod, displayName }) => {
        if (!paymentMethod) return;
        const label = displayName || paymentMethod;
        const codes = codesByLabel.get(label) || new Set();
        codes.add(paymentMethod);
        codesByLabel.set(label, codes);
    });

    return [...codesByLabel.entries()]
        .map(([label, codes]) => ({ value: [...codes].sort().join(','), label }))
        .sort((a, b) => a.label.localeCompare(b.label));
};
